module.exports = __webpack_public_path__ + "media/images/home/demo_left-9ddeae13f20a3b88bb3b6a53cd0302bf.png";